import React, { useContext } from 'react';
import { FocusLayerSizeV2 } from '@volkswagen-onehub/layer-manager';
import FactoryOrderModal from './FactoryOrderModal';
import { CTA } from '@volkswagen-onehub/components-core';
import { getTranslations } from '../../translations';
import { LayerContext, useFocusLayer } from '../../Layers';

export default () => {

    const { closeLayer } = useContext(LayerContext);

    const { error_messages: { no_stock } } = getTranslations();

    const openFactoryOrderConfirmationLayer = useFocusLayer('factory-order-layer', {
        size: FocusLayerSizeV2.C,
        onClose: () => closeLayer('factory-order-layer'),
    });

    const onFactoryModal = (e: React.SyntheticEvent<HTMLButtonElement>) => {
        e.preventDefault();
        openFactoryOrderConfirmationLayer((close) => <FactoryOrderModal close={close} />);
    }

    return (
        <CTA tag="button" emphasis='secondary' onClick={e => onFactoryModal(e)}>{ no_stock.factory_order }</CTA>
    );
}
